import type { TourConfig } from '../types';

export const partnerManagementPageTour: TourConfig = {
  pageId: 'partner-management',
  pageName: 'Partner Management',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="generate-link"]',
      title: 'Generate Access Link',
      intro:
        'Create a magic link for a referral partner to access their project dashboard. Select the company and business visibility.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="tokens-table"]',
      title: 'Access Links Table',
      intro:
        'View all generated partner access links with their status, creation date, last usage, and use count. Revoke or delete links as needed.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="partner-info"]',
      title: 'How It Works',
      intro:
        'Partners use magic links to view their referred projects and send notes. Each link is tied to a specific referral source company.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
